import React from "react";
import logo from "../Components/logo.png";
import PhoneIcon from "@material-ui/icons/Phone";
import title from "./title.png";
import "../css/Banner.css";
import "../css/Menu.css";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";

function Banner() {
  return (
    <div>
      <div class="box">
        <img src="https://images.pexels.com/photos/249348/pexels-photo-249348.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" />
        <center>
          <div id="sub-heading">
            <h4
              style={{
                color: "white",
              }}
            >
              Need help? Contact Us:
            </h4>

            <a href="tel:+919830310787">
              <div id="icon-text">
                <PhoneIcon
                  style={{
                    color: "white",
                    fontSize: 20,
                    marginRight: "0.1rem",
                    marginTop: "0.2rem",
                  }}
                  id="icon-container"
                />
                +91 9830310787
              </div>
            </a>

            <div>
              <a
                href="https://api.whatsapp.com/send?phone=919830310787"
                target="_blank"
              >
                <div id="icon-text">
                  <WhatsAppIcon
                    style={{
                      color: "white",
                      fontSize: 20,
                      marginRight: "0.3rem",
                      marginTop: "0.2rem",
                    }}
                    id="icon-container"
                  />
                  WhatsApp
                </div>
              </a>
            </div>

            <a href="tel:+919830310787">
              <button class="btn">Book Appointment</button>
            </a>
          </div>
        </center>
      </div>
    </div>
  );
}

export default Banner;
